import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { DefaultHttpRequest19v463zllbymg as DefaultHttpRequest } from '../request/DefaultHttpRequest.mjs';
import { DefaultHttpResponse2wnrinzo0twhn as DefaultHttpResponse } from '../statement/DefaultHttpResponse.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { instanceOf2cx3k00nj6a0p as instanceOf } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/TypeInfo.web.mjs';
import { get_isSaved1yor47kvbhumv as get_isSaved } from '../plugins/SaveBody.mjs';
import { HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer } from '../statement/HttpResponsePipeline.mjs';
import { NullBody_instance22vwyocs8eppk as NullBody_instance } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { cancel2ztysw4v4hav6 as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_request3dwcif5y0fvf1 as get_request } from '../statement/HttpResponse.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'CustomResponse';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = PrimitiveClasses_getInstance().get_anyClass_x0jl4l_k$();
        var tmp_1 = !(null == null);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_2;
        try {
          tmp_2 = createKType(PrimitiveClasses_getInstance().get_anyClass_x0jl4l_k$(), arrayOf([]), false);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp$ret$2 = tmp_2;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
        tmp.CustomResponse_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpClientCallClass;
function HttpClientCall() {
  if (HttpClientCallClass === VOID) {
    class $ {
      constructor(client) {
        return new.target.new_io_ktor_client_call_HttpClientCall_o2h3p8_k$(client);
      }
      static new_io_ktor_client_call_HttpClientCall_o2h3p8_k$(client) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.client_1 = client;
        $this.received_1 = atomic$boolean$1(false);
        $this.allowDoubleReceive_1 = false;
        return $this;
      }
      get_coroutineContext_115oqo_k$() {
        return this.get_response_xlk07e_k$().get_coroutineContext_115oqo_k$();
      }
      get_attributes_dgqof4_k$() {
        return this.get_request_jdwg4m_k$().get_attributes_dgqof4_k$();
      }
      get_request_jdwg4m_k$() {
        var tmp = this.request_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('request');
        }
      }
      get_response_xlk07e_k$() {
        var tmp = this.response_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('response');
        }
      }
      static new_io_ktor_client_call_HttpClientCall_kfyujo_k$(client, requestData, responseData) {
        Companion_getInstance();
        var $this = this.new_io_ktor_client_call_HttpClientCall_o2h3p8_k$(client);
        $this.request_1 = new (DefaultHttpRequest())($this, requestData);
        $this.response_1 = new (DefaultHttpResponse())($this, responseData);
        $this.get_attributes_dgqof4_k$().remove_2btyex_k$(Companion_getInstance().CustomResponse_1);
        var tmp = responseData.body_1;
        if (!isInterface(tmp, ByteReadChannel())) {
          $this.get_attributes_dgqof4_k$().put_gkntno_k$(Companion_getInstance().CustomResponse_1, responseData.body_1);
        }
        return $this;
      }
      get_allowDoubleReceive_um1gnm_k$() {
        return this.allowDoubleReceive_1;
      }
      *getResponseContent_9qb5np_k$($completion) {
        return this.get_response_xlk07e_k$().get_rawContent_u3f8li_k$();
      }
      *bodyNullable_wn8z59_k$(info, $completion) {
        try {
          if (instanceOf(this.get_response_xlk07e_k$(), info.type_1))
            return this.get_response_xlk07e_k$();
          if (!this.get_allowDoubleReceive_um1gnm_k$() && !get_isSaved(this.get_response_xlk07e_k$()) && !this.received_1.atomicfu$compareAndSet(false, true)) {
            throw DoubleReceiveException().new_io_ktor_client_call_DoubleReceiveException_ob42uk_k$(this);
          }
          var tmp0_elvis_lhs = this.get_attributes_dgqof4_k$().getOrNull_6mjt1v_k$(Companion_getInstance().CustomResponse_1);
          var responseData = tmp0_elvis_lhs == null ? (yield* this.getResponseContent_9qb5np_k$($completion)) : tmp0_elvis_lhs;
          var subject = new (HttpResponseContainer())(info, responseData);
          // Inline function 'kotlin.takeIf' call
          var this_0 = (yield* this.client_1.responsePipeline_1.execute_qsx0hz_k$(this, subject, $completion)).response_1;
          var tmp;
          if (!equals(this_0, NullBody_instance)) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var result = tmp;
          if (!(result == null) && !instanceOf(result, info.type_1)) {
            var from = getKClassFromExpression(result);
            var to = info.type_1;
            throw NoTransformationFoundException().new_io_ktor_client_call_NoTransformationFoundException_vs046n_k$(this.get_response_xlk07e_k$(), from, to);
          }
          return result;
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            cancel(this.get_response_xlk07e_k$(), 'Receive failed', cause);
            throw cause;
          } else {
            throw $p;
          }
        }
      }
      toString() {
        return 'HttpClientCall[' + this.get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ', ' + this.get_response_xlk07e_k$().get_status_jnf6d7_k$().toString() + ']';
      }
      setResponse_4r46xy_k$(response) {
        this.response_1 = response;
      }
    }
    initMetadataForClass($, 'HttpClientCall', VOID, VOID, VOID, [0, 1]);
    HttpClientCallClass = $;
  }
  return HttpClientCallClass;
}
var DoubleReceiveExceptionClass;
function DoubleReceiveException() {
  if (DoubleReceiveExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(call) {
        return new.target.new_io_ktor_client_call_DoubleReceiveException_ob42uk_k$(call);
      }
      static new_io_ktor_client_call_DoubleReceiveException_ob42uk_k$(call) {
        var $this = this.new_kotlin_IllegalStateException_1wtnp1_k$();
        captureStack($this, $this.$throwableCtor_4);
        $this.message_1 = 'Response already received: ' + call.toString();
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'DoubleReceiveException');
    DoubleReceiveExceptionClass = $;
  }
  return DoubleReceiveExceptionClass;
}
var NoTransformationFoundExceptionClass;
function NoTransformationFoundException() {
  if (NoTransformationFoundExceptionClass === VOID) {
    class $ extends UnsupportedOperationException() {
      constructor(response, from, to) {
        return new.target.new_io_ktor_client_call_NoTransformationFoundException_vs046n_k$(response, from, to);
      }
      static new_io_ktor_client_call_NoTransformationFoundException_vs046n_k$(response, from, to) {
        var $this = this.new_kotlin_UnsupportedOperationException_cv3bvm_k$();
        captureStack($this, $this.$throwableCtor_4);
        $this.message_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).get_url_18iuii_k$().toString() + '`\n        Response status `' + response.get_status_jnf6d7_k$().toString() + '`\n        Response header `ContentType: ' + response.get_headers_ef25jx_k$().get_6bo4tg_k$('Content-Type') + '` \n        Request header `Accept: ' + get_request(response).get_headers_ef25jx_k$().get_6bo4tg_k$('Accept') + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'NoTransformationFoundException');
    NoTransformationFoundExceptionClass = $;
  }
  return NoTransformationFoundExceptionClass;
}
//region block: exports
export {
  HttpClientCall as HttpClientCall2j6myj8ctykar,
};
//endregion

//# sourceMappingURL=HttpClientCall.mjs.map
